import { combineReducers } from 'redux';

import fieldIds from './fieldIds';
import information from './information';
import latestFieldId from './latestFieldId';
import positions from './positions';
import sizes from './sizes';
import target from './target';

export default combineReducers({
  fieldIds,
  information,
  latestFieldId,
  positions,
  sizes,
  target,
});
